import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { getLicenses } from './license.thunks';
import type { LicenseState } from './license.types';

export const getLicensesReducer = (builder: ActionReducerMapBuilder<LicenseState>): void => {
  builder.addCase(getLicenses.pending, state => {
    state.licenses.loading = 'pending';
  });
  builder.addCase(getLicenses.fulfilled, (state, action) => {
    state.licenses.data = action.payload;
    state.licenses.loading = 'succeeded';
  });
  builder.addCase(getLicenses.rejected, (state, action) => {
    state.licenses.loading = 'failed';
    state.licenses.error = action.error as Error;
  });
};
